import { Button, ButtonProps } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'

const SubmitButton = ({
  children,
  ...props
}: Omit<ButtonProps, 'isFullwidth' | 'isFullwidthMobile' | 'trailingIcon' | 'size' | 'representation'>) => {
  const { t } = useTranslation('common')

  return (
    <Button isFullwidth trailingIcon="chevronRight" size="large" {...props}>
      {children || t('continue')}
    </Button>
  )
}

export default SubmitButton
